<template>
  <el-table :data="drafts" row-key="platform">
    <el-table-column label="公开舆情平台" min-width="150">
      <template slot-scope="s">
        <strong>{{ s.row.display_name }}</strong>
        <div class="hint">{{ platformStatus(s.row) }}</div>
      </template>
    </el-table-column>
    <el-table-column label="能力验证" min-width="260">
      <template slot-scope="s">
        <el-tag v-if="!supported(s.row)" size="mini" type="info">{{ unsupportedLabel(s.row) }}</el-tag>
        <el-tag
          v-for="check in supported(s.row) ? ready(s.row).checks || [] : []"
          :key="check.key"
          :title="check.error_summary || ''"
          size="mini"
          :type="check.passed ? 'success' : 'info'"
        >
          {{ check.name }}{{ check.passed ? ' ✓' : ' 未通过' }}
        </el-tag>
        <div v-if="failureSummary(s.row)" class="hint error">{{ failureSummary(s.row) }}</div>
        <div v-else-if="supported(s.row) && ready(s.row).reason" class="hint">{{ ready(s.row).reason }}</div>
      </template>
    </el-table-column>
    <el-table-column label="自动舆情" width="100">
      <template slot-scope="s">
        <el-switch
          v-model="s.row.auto_monitor_enabled"
          :disabled="!supported(s.row) || !ready(s.row).search_ready"
        />
      </template>
    </el-table-column>
    <el-table-column label="舆情频率" width="150">
      <template slot-scope="s">
        <el-input-number
          v-model="s.row.monitor_interval_minutes"
          :min="30"
          :disabled="!supported(s.row)"
          controls-position="right"
        />
        <span class="unit">分钟</span>
      </template>
    </el-table-column>
    <el-table-column label="评论页数" width="130">
      <template slot-scope="s">
        <el-input-number
          v-model="s.row.comment_page_limit"
          :min="0"
          :max="20"
          :disabled="!supported(s.row)"
          controls-position="right"
        />
      </template>
    </el-table-column>
    <el-table-column label="请求上限" width="130">
      <template slot-scope="s">
        <el-input-number
          v-model="s.row.max_requests"
          :min="1"
          :max="500"
          :disabled="!supported(s.row)"
          controls-position="right"
        />
      </template>
    </el-table-column>
    <el-table-column label="操作" width="170">
      <template slot-scope="s">
        <el-button
          size="mini"
          :loading="verifying === s.row.platform"
          :disabled="!supported(s.row) || (Boolean(verifying) && verifying !== s.row.platform)"
          @click="$emit('verify', s.row)"
        >
          {{ ready(s.row).search_ready ? '重新验证' : '执行验证' }}
        </el-button>
        <el-button type="primary" size="mini" :disabled="!supported(s.row)" @click="$emit('save', s.row)">保存</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: ['value', 'readiness', 'endpoints', 'verifying'],
  data () {
    return { drafts: [] }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        this.drafts = (value || []).map(item => ({
          ...item,
          monitor_interval_minutes: item.monitor_interval_minutes || 360,
          refresh_interval_minutes: item.refresh_interval_minutes || 360,
          comment_page_limit: item.comment_page_limit || 0,
          max_requests: item.max_requests || 20
        }))
      }
    }
  },
  methods: {
    ready (row) {
      return (this.readiness || []).find(item => item.platform === row.platform) || {}
    },
    supported (row) {
      const readiness = this.ready(row)
      return readiness.adapter_status ? readiness.adapter_status === 'adapted' : Boolean(readiness.platform)
    },
    tikhubUnsupported (row) {
      return this.ready(row).adapter_status === 'tikhub_unsupported' || (this.endpoints || []).some(item => item.platform === row.platform && item.entry_type === 'keyword_search' && item.path_status === 'TikHub不支持')
    },
    unsupportedLabel (row) {
      return this.ready(row).support_reason || (this.tikhubUnsupported(row) ? 'TikHub 不支持公开搜索接口' : '项目暂未适配，需要开发接入')
    },
    platformStatus (row) {
      if (!this.supported(row)) return this.unsupportedLabel(row)
      return this.ready(row).search_ready ? '已通过实测' : '已适配，验证通过后可开启'
    },
    failureSummary (row) {
      const messages = (this.ready(row).checks || [])
        .filter(check => !check.passed && check.error_summary)
        .map(check => check.error_summary)
      return Array.from(new Set(messages)).join('；')
    }
  }
}
</script>

<style scoped>
.hint {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
}
.error {
  color: #f56c6c;
}
.unit {
  margin-left: 4px;
  color: #909399;
  font-size: 12px;
}
.el-tag {
  margin: 2px;
}
</style>
